export const deliverabilityPostmasterAppGroupIdComplianceStatus =
  "/deliverability/postmaster/:app_group_id/compliance_status";
